/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';

export const SvgMessagesRed = ({ size }) => {
    return (<Svg width={size} height={size} viewBox="0 0 30 30">
        <G fill="none" fill-rule="evenodd" transform="translate(1 1)">
            <Circle cx="14" cy="14" r="14" stroke="#FFFFFF"></Circle>
            <Circle cx="14" cy="14" r="13" fill="#FF0000"></Circle>
            <G fill="#FFFFFF" transform="translate(5 7)">
                <Rect width="18" height="1" rx=".5"></Rect>
                <Path d="M0,13.5 C0,13.2238576 0.227586508,13 0.500209719,13 L17.4997903,13 C17.7760485,13 18,13.2319336 18,13.5 L18,13.5 C18,13.7761424 17.7743429,14 17.4948183,14 L8.08766413,14 L0.505919613,14 C0.226507926,14 0,13.7680664 0,13.5 L0,13.5 Z"></Path>
                <Path d="M-0.945592857,10.1304096 C-0.945592857,9.8542672 -0.726305393,9.63040957 -0.443225115,9.63040957 L7.42316488,9.63040957 C7.70061492,9.63040957 7.92553262,9.86234316 7.92553262,10.1304096 L7.92553262,10.1304096 C7.92553262,10.4065519 7.70293151,10.6304096 7.42113049,10.6304096 L3.040334,10.6304096 L-0.440772467,10.6304096 C-0.71957707,10.6304096 -0.945592857,10.398476 -0.945592857,10.1304096 L-0.945592857,10.1304096 Z" transform="rotate(-45 3.49 10.13)"></Path>
                <Path d="M9.97175842,10.0462998 C9.97175842,9.77015747 10.1910459,9.54629984 10.4741262,9.54629984 L18.3405162,9.54629984 C18.6179662,9.54629984 18.8428839,9.77823343 18.8428839,10.0462998 L18.8428839,10.0462998 C18.8428839,10.3224422 18.6202828,10.5462998 18.3384818,10.5462998 L13.9576853,10.5462998 L10.4765788,10.5462998 C10.1977742,10.5462998 9.97175842,10.3143662 9.97175842,10.0462998 L9.97175842,10.0462998 Z" transform="rotate(-135 14.407 10.046)"></Path>
                <Rect width="14" height="1" x="10.5" y="6.5" transform="rotate(90 17.5 7)" rx=".5"></Rect>
                <Rect width="14" height="1" x="-6.5" y="6.5" transform="rotate(90 .5 7)" rx=".5"></Rect>
                <Rect width="2" height="1" x="8" y="8" rx=".5"></Rect>
                <Rect width="11.146" height="1" x="-.748" y="4.447" transform="rotate(44 4.825 4.947)" rx=".5"></Rect>
                <Rect width="11.397" height="1" x="7.48" y="4.311" transform="rotate(135 13.179 4.811)" rx=".5"></Rect>
            </G>
        </G>
    </Svg>)
}
